export function formatJSONStringToMap(jsonString: string): Map<string, string> {
  const obj = JSON.parse(jsonString);
  return new Map(Object.entries(obj));
}
